/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Secret key in PEM-encoded EC format.
 * Examples on how to generate it by openssl:
 *   openssl genpkey -algorithm ed25519
 *   openssl ecparam -name secp256r1 -noout -genkey
 *   openssl ecparam -name secp384r1 -noout -genkey
 *   openssl ecparam -name secp256k1 -noout -genkey
 * .
 */
export type KeySecretEc = string;
